"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Avatar"));
var Avatar_1 = require("./Avatar");
exports.default = Avatar_1.default;
//# sourceMappingURL=index.js.map